import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT, EnvType } from '../../APIConstants';
import { getAGraphBaseUrl, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_ACCOUNT_MANAGEMENT_API_URL, AW_CIS_API_URL, AW_CIS_BETA_API_URL } from './Constants';
import { betaCisAllowedPkgs, getUrlParam } from './utils';
interface Settings extends AGraphApiSettings {
  getEnvTypeFn?: () => EnvType;
  getPkgFn?: () => string | undefined;
}

export const awAccountManagementSettings: Settings = {};
export const awExternalPicklistSettings: Settings = {};

export const awAccountManagementApi = axios.create();
export const awExternalPicklistApi = axios.create();

awAccountManagementApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awAccountManagementSettings;

  const configurationDirectory = getConfigurationDirectoryFn?.();
  const baseURL = getAGraphBaseUrl(AW_ACCOUNT_MANAGEMENT_API_URL);
  const pkg = getUrlParam('pkg') || getPkgFn?.() || '';

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      pkg,
      configurationDirectory,
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());

  return updatedConfig;
});

awExternalPicklistApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { getAladdinApiKey, getConfigurationDirectoryFn, getEnvTypeFn, getPkgFn } = awExternalPicklistSettings;

  const configurationDirectory = getConfigurationDirectoryFn?.();
  const pkg = getUrlParam('pkg') || getPkgFn?.() || '';
  /*
   * Use beta URL for UAP_UAT and UAP_SIT packages, otherwise use regular URL.
   * TODO: UAP_SIT temporarily points to beta CIS instance until a dedicated CIS SIT instance is available.
   */
  const baseURL = betaCisAllowedPkgs.includes(pkg) ? AW_CIS_BETA_API_URL : AW_CIS_API_URL;

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.(), 'channel', false);

  return updatedConfig;
});
